export const APPLICATION_LIST = [
  "Command Center",
  "IO - Safety Stock Approval",
  "CS - Inventory Rebalancing",
  "MP - Lead time Analytics",
  "MP - AL Contract Automation",
  "MP - AL Supplier Collaboration/Confirmation",
  // "MP - Supplier Confirmation",
  "MP - AL PO Management",
  "MP - GR Processing Time Analytics",
  "OM - Load Optimization",
  "Data Trust AI",
  "S&OP - Sales And Operations Planning",
];

export const APPLICATION_LIST_ALL = [
  "All",
  ...APPLICATION_LIST
];

export const APPLICATION_TYPE_MAP = {
  "Command Center": "COMMANDCENTER",
  "IO - Safety Stock Approval": "SAFETY_STOCK",
  "CS - Inventory Rebalancing": "INVENTORY_REBALANCING",
  "MP - Lead time Analytics": "LEAD_TIME_ANALYTICS",
  "MP - AL Contract Automation": "AL_CONTRACT_AUTOMATION",
  "MP - AL Supplier Collaboration/Confirmation": "AL_SUPPLIER_COLLABORATION",
  "MP - AL Supplier Collaboration": "AL_SUPPLIER_COLLABORATION",
  "MP - Supplier Confirmation": "SUPPLIER_CONFIRMATION",
  "MP - AL PO Management": "PO_MAINTENANCE",
  "OM - Load Optimization": "OM_LOAD_OPTIMISATION",
  "MP - GR Processing Time Analytics": "GRPT",
  "Data Trust AI": "DTAI",
  "S&OP - Sales And Operations Planning": "SALES_AND_OPERATIONAL_PLANNING",
  "All": "ALL"
};

export const APPLICATION_TYPE_MAP_REPORT = {
  ...APPLICATION_TYPE_MAP,
  "IO - Safety Stock Approval": "SSA"
};

export const APPLICATION_LABEL_MAP = {
  COMMANDCENTER: "Command Center",
  SSA: "IO - Safety Stock Approval",
  SAFETY_STOCK: "IO - Safety Stock Approval",
  INVENTORY_REBALANCING: "CS - Inventory Rebalancing",
  LEAD_TIME_ANALYTICS: "MP - Lead time Analytics",
  AL_CONTRACT_AUTOMATION: "MP - AL Contract Automation",
  AL_SUPPLIER_COLLABORATION: "MP - AL Supplier Collaboration/Confirmation",
  SUPPLIER_CONFIRMATION: "MP - Supplier Confirmation",
  PO_MAINTENANCE: "MP - AL PO Management",
  GRPT: "MP - GR Processing Time Analytics",
  OM_LOAD_OPTIMISATION: "OM - Load Optimization",
  DTAI: "Data Trust AI",
  SALES_AND_OPERATIONAL_PLANNING: "S&OP - Sales And Operations Planning",
  ALL: "All"
};

export const pdfPages = {
  "new-request": { page: 3 },
  "track-access-request": { page: 16 },
  reports: { page: 19 },
  "approval-rights": { page: 20 },
  "ticket-summary": { page: 21 },
  "admin-portal": { page: 22 }
};